import React from "react";
import styles from "./Block.module.css";

export default function Image({ src }) {
	return (
		<div className={styles.imageBlock}>
			<img className={styles.image} src={src} alt="" />
		</div>
	);
}
